import type React from 'react';

import { TrackExperimentExposure } from '#src/app/shared/components/tracking';
import { useSessionConfiguration } from '#src/app/shared/hooks/sessionConfiguration';

/**
 * Fires `$exposure` for the session-level `dark_mode_rollout` experiment the moment session
 * configuration is available, so the percentage-rollout ramp (see FCM_DARK_MODE_ROLLOUT_EXPERIMENT /
 * EXPERIMENT_DARK_MODE_ROLLOUT) has a dedicated exposure event to anchor analysis on, independent of
 * the darkModeEnabled kill-switch.
 */
export const DarkModeRolloutExposure: React.FC = () => {
	const { experiments } = useSessionConfiguration();

	return <TrackExperimentExposure experiment={experiments.darkModeRollout} />;
};
